(function () {
  'use strict';

  angular.module('app').component('hotelInventoryList', hotelInventoryList());

  function hotelInventoryList() {
    return {
      bindings: {
        calendarDays: '=',
        inventory: '=',
        onInventorySaved: '&',
      },
      controller: HotelInventoryListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/hotel-inventories/hotel-inventory-list/hotel-inventory-list.component.html',
    };
  }

  HotelInventoryListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'AbilityService',
    'moment',
    'HotelInventoryService',
  ];

  function HotelInventoryListCtrl(
    config,
    UtilService,
    $translate,
    $filter,
    AbilityService,
    moment,
    HotelInventoryService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    vm.permissions = {
      canCreate: AbilityService.can('create_hotelinventory_accountadmin'),
      canUpdate: AbilityService.can('update_hotelinventory_accountadmin'),
      canSaveByDates: AbilityService.can('change_total_by_dates_hotelinventory_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY_LARGE;
    // vm.hourDisplay      = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.todayDateFormat = moment().format('YYYY-MM-DD');

    // Methods
    vm.openHotelInventoryModal = openHotelInventoryModal;
    vm.popoverPlacement = popoverPlacement;

    // Open the modal for masive add or update by date range
    function openHotelInventoryModal(hotel, room) {
      // if (!hotel.has_prices){
      //     return;
      // }

      if (vm.permissions.canSaveByDates) {
        var selectedItem = hotel;
        var title = hotel.name;

        var inventory = {
          hotel_id: hotel.id,
          title: title,
          hotel_room_id: null,
        };

        if (room) {
          // if (!room.has_prices){
          //     return;
          // }

          selectedItem = room;
          inventory.hotel_room_id = room.id;
          inventory.title = title + ' / ' + room.name;
        }

        var successCallback = function () {
          vm.onInventorySaved({ item: selectedItem });
        };

        HotelInventoryService.openHotelInventoryModal(inventory, successCallback);
      }
    }

    // Sets the popover placement (Left or Right)
    function popoverPlacement($index) {
      if (vm.calendarType === 'Month') {
        if ($index < 15) {
          return 'right';
        }
      }
      return 'left';
    }

    vm.popoverAdd = {
      templateUrl: 'template_add.html',
      open: function open(item) {
        vm.newInventory = {
          total_availability: 0,
        };

        item.popoverAddIsOpen = true;

        vm.selectedItem = item;
        vm.confirmCheckBox = false;
      },
      close: function close(item) {
        item.popoverAddIsOpen = false;
        vm.selectedItem = null;
      },
      save: function save() {
        vm.selectedItem.total_availability = vm.newInventory.total_availability;

        saveHotelInventory();
      },
    };

    // Consider a sidebar modal with bokings created as reference
    vm.popoverUpdate = {
      templateUrl: 'template_update.html',
      open: function open(item) {
        vm.totalAvailabilityCopy = angular.copy(item.total_availability);
        item.popoverUpdateIsOpen = true;

        vm.selectedItem = item;
        vm.confirmCheckBox = false;
      },
      close: function close(item) {
        item.popoverUpdateIsOpen = false;
        vm.selectedItem = null;
      },
      save: function save() {
        vm.selectedItem.total_availability = vm.totalAvailabilityCopy;

        saveHotelInventory();
      },
    };

    // Save-Update
    function saveHotelInventory() {
      vm.sendingForm = true;
      HotelInventoryService.saveHotelInventory(vm.selectedItem).then((response) => {
        if (response) {
          vm.selectedItem.popoverUpdateIsOpen = false;
          vm.selectedItem = null;

          vm.sendingForm = false;
        }
      });
    }
  }
})();
